import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import {
  ScheduledStartDateValidatorDirective,
  ScheduleUtilityRateFormComponent,
} from './schedule-utility-rate-form.component';
import { SuiFormsModule } from '@spog-ui/shared/components';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    SuiFormsModule,
  ],
  declarations: [ScheduleUtilityRateFormComponent, ScheduledStartDateValidatorDirective],
  exports: [ScheduleUtilityRateFormComponent],
})
export class ScheduleUtilityRateFormModule {}
